// extracted by mini-css-extract-plugin
export default {"style":"FormulaireAxe_style__BlWV8","input":"FormulaireAxe_input__+hQC9"};